class FeaturedProductGallery {
  constructor(gallery) {
    this.gallery = gallery;
    this.viewer = gallery.querySelector('[id^="GalleryViewer"]');
    this.prevButton = this.viewer?.querySelector('button[name="previous"]');
    this.nextButton = this.viewer?.querySelector('button[name="next"]');
    this.mql = window.matchMedia('(min-width: 750px)');

    if (!this.viewer || !this.prevButton || !this.nextButton) return;

    this.mql.addEventListener('change', () => this.updateArrowState());
    this.prevButton.addEventListener('click', (event) => this.onArrowClick(event, 'prev'), true);
    this.nextButton.addEventListener('click', (event) => this.onArrowClick(event, 'next'), true);
    this.viewer.addEventListener('slideChanged', () => this.updateArrowState());

    this.observer = new MutationObserver(() => this.updateArrowState());
    this.slides.forEach((slide) => {
      this.observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });

    this.updateArrowState();
  }

  get slides() {
    return Array.from(this.viewer.querySelectorAll('.product__media-item[data-media-id]'));
  }

  get activeIndex() {
    return this.slides.findIndex((slide) => slide.classList.contains('is-active'));
  }

  onArrowClick(event, direction) {
    const isThumbnailLayout = this.gallery.dataset.desktopLayout?.includes('thumbnail');
    if (!this.mql.matches || !isThumbnailLayout) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const currentIndex = this.activeIndex;
    const nextIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
    if (nextIndex < 0 || nextIndex >= this.slides.length) return;

    this.gallery.setActiveMedia(this.slides[nextIndex].dataset.mediaId, false);
    this.updateArrowState();
  }

  updateArrowState() {
    const isThumbnailLayout = this.gallery.dataset.desktopLayout?.includes('thumbnail');
    if (!this.mql.matches || !isThumbnailLayout || this.slides.length < 2) {
      this.prevButton.removeAttribute('disabled');
      this.nextButton.removeAttribute('disabled');
      return;
    }

    const currentIndex = this.activeIndex;

    if (currentIndex <= 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (currentIndex >= this.slides.length - 1) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }
}

function initFeaturedProductGalleries() {
  document.querySelectorAll('.featured-product media-gallery').forEach((gallery) => {
    if (gallery.featuredProductGallery) return;
    gallery.featuredProductGallery = new FeaturedProductGallery(gallery);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFeaturedProductGalleries);
} else {
  initFeaturedProductGalleries();
}

document.addEventListener('shopify:section:load', initFeaturedProductGalleries);
